import Footer from "./home/Footer/Footer";
import NavBar from "./home/NavBarHeader/Navbar/NavBar";

const ErrorPage = () => {
  return (
    <div>
      <NavBar />
      <h3 className="text-center my-5">Page Not Found.</h3>
      <Footer />
    </div>
  );
};
export default ErrorPage;
